import { Space, Input, Button } from 'antd';
import { Backdrop, CircularProgress, ListItemIcon, Button as ButtonI, ButtonGroup, Grid } from '@mui/material';
import { Form } from 'antd';
import { Box, Menu, MenuItem } from '@mui/material';
import Table, { ColumnsType } from 'antd/es/table';
import BeenhereIcon from '@mui/icons-material/Beenhere';
import BlockIcon from '@mui/icons-material/Block';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import { SearchOutlined } from '@mui/icons-material';
import Fade from '@mui/material/Fade';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import SchemaIcon from '@mui/icons-material/Schema';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventIcon from '@mui/icons-material/Event';
import SweetAlert from 'sweetalert2';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Data from '../../../Data/Data.json';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import InputForm from '../../InputT';
import SearInputM from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Utilisateur from '../../../Models/Utilisateur';
import { Crypter } from '../../../Functions/Security/Crypter';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
import AvisOp from '../../../Types/AvisOp';
import ReformatNumber from '../../../Functions/Traitement/ReformatNumber';
import axios from 'axios';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import { PDFExport, savePDF } from '@progress/kendo-react-pdf';
import ExcelIcon from '../../../Res/ExcelIcon.svg';
import { useAgence } from '../../../AgenceContext';
import { PrintHistCompteDirect } from '../../../utilitaires/globalFunction';
import { PrintEcritureByRefDirect } from '../../../utilitaires/globalFunction';
import { PrintEcritureByLineDirect } from '../../../utilitaires/globalFunction';

//Initialisation des parametres de recherche 
let searchAgence: ParamsPicklist = { CodeAgence: '', Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }

const Tab1 = (props: { form: any, Function?: Function, DataHistor: DataHistoCpt[] }) => {

  const auth = useAuthUser();
   const Branch=useAgence();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  // USER TOKEN
  const authHeader = useAuthHeader();

  const [Reccord, SetReccord] = useState<any>("");
  //loading Boutton  
  const [loading, setLoading] = useState(false);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRecord, setSelectedRecord] = useState<any>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>, record: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedRecord(record);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRecord(null);
  };

  const [SearchR, SetSearchR] = useState<string>("");
  const navigate = useNavigate();

  const [start, setstart] = useState(false); const _exporter = React.createRef<ExcelExport>();
  //donnee à exporté sous excel
  const [DataExcel, SetDataExcel] = useState<DataHistoCpt[]>([]);

  const handleExport = () => {
    setLoading(false);
  }


  useEffect(() => {
    if (start == false) {

      let DateD = user.datjour.substring(0, 4) + '-01-01';
      props.form.setFieldValue("datD", DateD);
      props.form.setFieldValue("DatF", user.datjour);
      setstart(true)
      // props.form.setFieldValue("datD",'10-02-2022')
    }

  }, []);

  const exportExcel = () => {
    setLoading(true);
    SetDataExcel([]);

    props.DataHistor.map((data: any, indice: any) => {
      DataExcel.push({
        key: indice,
        DATOPE: data.DATOPE,
        TIME: data.TIME,
        DEDEVR: data.DEDEVR,
        REPECE: data.REPECE,
        NUMRAP: data.NUMRAP,
        LIBELL: data.LIBELL,
        MONTANTDEBIT: ReformatNumber(data.MONTANTDEBIT ? data.MONTANTDEBIT : ''),
        MONTANTCREDIT: ReformatNumber(data.MONTANTCREDIT ? data.MONTANTCREDIT : ''),
        SOLDT: ReformatNumber(data.SOLDT),
        NBENEF: data.NBENEF,
        UTISAI: data.UTISAI,
        NLIGNE: data.NLIGNE
      })
    })

    if (!_exporter.current) {
      return;
    }
    setLoading(true);
    _exporter.current.save();
  };



  let informationclient = {
    SearchAgence: {
      Titre: "Recherche Agence",
      label: "Agence",
      name: "AGCCPT", params: searchAgence
    },
    InputDatDeb: {
      label: "Date début",
      name: "datD"
    },
    InputDatDef: {
      label: "Date Fin",
      name: "DatF"
    },
    SearchCompte: {
      Titre: "Recherche Compte",
      label: "Comptes",
      name: "NUMCPT", params: searchCompte
    }
  }


  const HandlerPrint = async (Op: number, record: any) => {
    setLoading(true);

    switch (Op) {
      case 1:
        {
          setLoading(true);
          let AvsOp: AvisOp = record;
           
          if (ReformatNumber(record.MONTANTCREDIT) == 0) {
            AvsOp.MONTANT = record.MONTANTDEBIT;
          } else if (ReformatNumber(record.MONTANTDEBIT) == 0)
            AvsOp.MONTANT = record.MONTANTCREDIT;

          localStorage.removeItem(Data.LocalVariable.tabAvisOpe);

          localStorage.setItem(Data.LocalVariable.tabAvisOpe, JSON.stringify({ "columns": columnAvisOPe, "record": [AvsOp],"P":"S","form": props.form.getFieldsValue() }))

         // navigate("/SituationClient/print/AvisOpération");
            PrintEcritureByLineDirect(
                                        user.coduti ?? '',
                                        user.codage ?? '',
                                        Branch.agence?.LIBELLE ?? '',
                                        Branch.agence?.BANQUE ?? '',
                                        Branch.agence?.TELEPH ?? '',
                                        Branch.agence?.NUMREG ?? '',
                                        Branch.agence?.LICENCE ?? '',
                                        props.form.getFieldValue("NUMCLI") ?? '', // NumCon should be client number
                                        Branch.agence?.BPOSTE ?? '',
                                        Branch.agence?.VILLE ?? '',
                                        user.nomuti ?? '',
                                        record.REPECE ?? '',
                                        record.NLIGNE ?? '',                                                                                                                           
                                        "HISTORIQUE",
                                        "PDF"
                                       )
         
          
        }
        break;
      case 2:
        {

         // alert( Branch.agence?.LIBELLE ?? '')
          if (typeof record.REPECE != 'undefined' && record.REPECE != '') {
            let config = {
              method: 'get',
              maxBodyLength: Infinity,
              url: Data.ApiUrl.GetSheComptable,
              headers: {
                               'CypherUtilis': Crypter.encrypt(user.coduti),
                                'CypherAgence': Crypter.encrypt(user.codage),
                                'CypherReference': Crypter.encrypt(record.REPECE),
                                'CypherLigne': Crypter.encrypt(record.NLIGNE),
                                'CypherType': Crypter.encrypt("avis"),
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                // 'CypherUtilis': Crypter.encrypt(user.coduti),
                // 'CypherAgence': Crypter.encrypt(user.codage),
                // 'CypherReference': Crypter.encrypt(record.REPECE),
                // 'Authorization': authHeader(),
                // 'Content-Type': 'application/json'
              }
            };

            await axios.request(config)
              .then((response) => {
                if (response.data) {
                  const res = JSON.parse(Crypter.decrypt(response.data));
 
                  if (res.StatutCode == 200) {

                    if (res.Result.Table.length > 0) {

                      const Datat: DataHistoCpt[] = [];
                      let RePorSolde: number = 0;
                      let TotalDebit: number = 0;
                      let TotalCrebit: number = 0;
                      let NbrCrebit: number = 0;
                      let Nbrdebit: number = 0;

                      res.Result.Table.map((data: any, indice: number) => {
                        RePorSolde += data.MONTANTCREDIT - data.MONTANTDEBIT;

                        if (data.MONTANTDEBIT > 0) Nbrdebit++;
                        else NbrCrebit++;

                        Datat.push({
                          key: indice,
                          NOMCPT: data.NOMCPT,
                          NUMCPT: data.noducp,
                          DATOPE: (new Date(data.DATOPE.substring(0, 10))).toLocaleDateString("fr"),
                          TIME: data.TIME.substring(11,),
                          DEDEVR: (new Date(data.DEDEVR.substring(0, 10))).toLocaleDateString("fr"),
                          REPECE: data.REPECE,
                          NUMRAP: data.NUMRAP,
                          LIBELL: data.LIBELL,
                          MONTANTDEBIT: formatNumber(data.MONTANTDEBIT ? data.MONTANTDEBIT : ''),
                          MONTANTCREDIT: formatNumber(data.MONTANTCREDIT ? data.MONTANTCREDIT : ''),
                          SOLDT: formatNumber(RePorSolde),
                          NBENEF: data.NBENEF,
                          UTISAI: data.UTISAI,
                          NLIGNE: data.NLIGNE
                        });

                        //Incrémentation des Montants Totaux
                        TotalDebit += data.MONTANTDEBIT;
                        TotalCrebit += data.MONTANTCREDIT;
                      })

                      // form.setFieldValue("ReportSold", formatNumber(RePorSoldeI));
                      localStorage.removeItem(Data.LocalVariable.SheComptable);

                      const SchemaInfo = {
                        "DateOpe": props.DataHistor[record.key].DATOPE,
                        "reference": record.REPECE,
                        "TotalDebit": TotalDebit,
                        "TotalCrebit": TotalCrebit,
                        "Nbrdebit": Nbrdebit,
                        "NbrCrebit": Nbrdebit
                      }

                      localStorage.setItem(Data.LocalVariable.SheComptable, JSON.stringify({ "columns": columnSheComptable, "data": Datat, "form": props.form.getFieldsValue(),"P":"S", "SchemaInfo": SchemaInfo }));

                      //navigate("/SituationClient/print/Schemacomptable");
                        // PrintEcritureByRefDirect(
                        //                                                             user.coduti ?? '',
                        //                                                             user.codage ?? '',
                        //                                                             Branch.agence?.LIBELLE ?? '',
                        //                                                             Branch.agence?.BANQUE ?? '',
                        //                                                             Branch.agence?.TELEPH ?? '',
                        //                                                              Branch.agence?.NUMREG ?? '',
                        //                                                              Branch.agence?.LICENCE ?? '',
                        //                                                              Branch.agence?.NUMREG ?? '',
                        //                                                              Branch.agence?.BPOSTE ?? '',
                        //                                                              Branch.agence?.VILLE ?? '',
                        //                                                             user.nomuti ?? '',
                        //                                                             record.REPECE ?? '',
                        //                                                             record.REPECE ?? '',                                                                                                                          
                        //                                                             "HISTORIQUE",
                        //                                                             "PDF"
                        //                                                           )

                           PrintEcritureByRefDirect(
                                                     user.coduti ?? '',
                                                     user.codage ?? '',
                                                     Branch.agence?.LIBELLE ?? '',
                                                     Branch.agence?.BANQUE ?? '',
                                                     Branch.agence?.TELEPH ?? '',
                                                     Branch.agence?.NUMREG ?? '',
                                                     Branch.agence?.LICENCE ?? '',
                                                     props.form.getFieldValue("NUMCLI") ?? '', // NumCon should be client number
                                                     Branch.agence?.BPOSTE ?? '',
                                                     Branch.agence?.VILLE ?? '',
                                                     user.nomuti ?? '',
                                                     record.REPECE ?? '',
                                                     record.REPECE ?? '',                                                                                                                           
                                                     "HISTORIQUE",
                                                     "PDF"
                                                  )
                    } else {
                      setLoading(false);
                      SweetAlert.fire({ title: "Warning", text: "pas shéma sur cette opération", icon: "warning" })
                    }
                  }
                  else {
                    setLoading(false);
                    SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                  }
                }
              })
              .catch((error) => {
                console.log(error)
                SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
              });
          }
          else {
            setLoading(false);
            SweetAlert.fire({ title: "Error", text: "Réference Non Valide", icon: "error" })
          }
        }

        break;
      default:

    }

    setLoading(false);
  }


  //Schéma comptable d'une Opération
  const columnSheComptable: ColumnsType<DataHistoCpt> = [
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'NOMCPT',
      dataIndex: 'NOMCPT',
      align: 'center',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Date Opération ',
      dataIndex: 'DATOPE',
      align: 'center',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      ellipsis: true,
      width: 100,
    },
    // {
    //   title: 'Date Valeur',
    //   dataIndex: 'DEDEVR',
    //   ellipsis: true,
    //   width: 100,
    // },
    {
      title: 'Reference',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      align: 'left',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Montant  Debit',
      dataIndex: 'MONTANTDEBIT',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Montant Credit',
      dataIndex: 'MONTANTCREDIT',
      align: 'center',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      ellipsis: true,
      width: 150,
    }

  ];

  //colonne des Avis des Opérations
  const columnAvisOPe: ColumnsType<DataHistoCpt> = [
    {
      title: 'Date Opération ',
      dataIndex: 'DATOPE',
      align: 'center',
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      align: 'center',
   
    },
    {
      title: 'Date De Valeur',
      dataIndex: 'DEDEVR',
      align: 'center',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Reference',
      dataIndex: 'REPECE',
      align: 'center',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      align: 'left',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'MONTANT',
      dataIndex: 'MONTANT',
      align: 'center',
      width: 120,
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      align: 'center',
      ellipsis: true,
      width: 200,
    }
  ]

  const columns: ColumnsType<DataHistoCpt> = [
    {
      title: 'Date Opération ',
      dataIndex: 'DATOPE',
      ellipsis: true,
      width: 100,
      align: 'left',
      filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.DATOPE)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.TIME)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.DATCRE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.REPECE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.NUMRAP)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.MONTANTDEBIT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.MONTANTCREDIT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.NBENEF)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.UTISAI)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.SOLDT)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Heure',
      dataIndex: 'TIME',
      ellipsis: true,
      width: 100,
      align: 'left',
    },
    {
      title: 'Date Valeur',
      dataIndex: 'DEDEVR',
      ellipsis: true,
      width: 100,
      align: 'left',
    },
    {
      title: 'Ref Automatique',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 130,
      align: 'left',
    },
    {
      title: 'Ref Manuelle',
      dataIndex: 'NUMRAP',
      ellipsis: true,
      width: 120,
      align: 'left',
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      ellipsis: true,
      width: 200,
    },
    {
      title: 'Debit',
      dataIndex: 'MONTANTDEBIT',
      ellipsis: true,
      width: 100,
      align:"right"
    },
    {
      title: 'Credit',
      dataIndex: 'MONTANTCREDIT',
      ellipsis: true,
      width: 100,
      align:"right"
    },
    {
      title: 'Solde Total',
      dataIndex: 'SOLDT',
      ellipsis: true,
      width: 100,
      align:"right"
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      ellipsis: true,
      width: 120,
    },
    {
      title: 'Utisai',
      dataIndex: 'UTISAI',
      ellipsis: true,
      width: 70,
    },
     {
      title: 'Sequence',
      dataIndex: 'NLIGNE',
      ellipsis: true,
      width: 70,
    },
    {
      title: 'Actions',
      dataIndex: 'Avis',
      width: 70,
      render: (_, record) => (
        <>
          <Button size='small' aria-controls={open ? 'fade-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined} onClick={(e) => handleClick(e, record)}>
            <LocalPrintshopIcon ></LocalPrintshopIcon>
            <ArrowDropUpIcon></ArrowDropUpIcon>
          </Button>
          <Menu id="fade-menu" MenuListProps={{ 'aria-labelledby': 'fade-button', }} anchorEl={anchorEl} open={open} onClose={handleClose} TransitionComponent={Fade}>
            <MenuItem onClick={() => {  
             
             HandlerPrint(1, selectedRecord)
             handleClose();
             }} ><ListItemIcon> <BorderColorIcon /> </ListItemIcon>Avis Opération </MenuItem>
            <MenuItem onClick={() => { 
           
                HandlerPrint(2, selectedRecord)
                handleClose();
                }}><ListItemIcon> <SchemaIcon /></ListItemIcon> Afficher Lot comptable</MenuItem>
          </Menu>
        </>
      )
    }
  ];

  //Vérification des dates
  const handleChangeFin = (e: any) => {
    const dateD = props.form.getFieldValue("datD");

    if (e.target.value <= dateD) {
      props.form.setFieldValue("DatF", '');
      SweetAlert.fire({ title: "Saisie Invalide", text: " la date de fin doit  être supérieur à la date de fin ", icon: "error" });
    }

    if (dateD == '' || typeof dateD == 'undefined') {
      SweetAlert.fire({ title: "Saissie Invalide", text: " Veuillez Saisir la date debut ", icon: "error" });
      props.form.setFieldValue("DatF", '');
    }
  };

  const sufix = (
    <TravelExploreIcon
      color='success'
      style={{
        fontSize: 16,
        color: '#1677ff',
      }}
    />
  );

  return (
    <>
      <div className='tabItem' >
        
          <Box fontStyle={"inherit"}   className='bordure1'  position={"absolute"} style={{ width: '85%' }}>

            <Box fontStyle="inherit" display={"flex"} className='bordure1'>
                 <InputForm disabled icon={<LocalAtmIcon />} notRequired width={7} label="Minimun" name="SOLMIN" type='text' />
                 <InputForm disabled icon={<BlockIcon />} notRequired width={6} label="Bloqué" name="BLOQUE" type='text' />
                  <InputForm disabled icon={<BeenhereIcon color='success' />} notRequired width={8} label="Autorisation" name="AUTORI" type='text' />
                  <InputForm disabled icon={<BeenhereIcon color='success' />} notRequired width={7} label="Disponile" name="DISPON" type='text' />
            </Box>
          
               <Box fontStyle="inherit"  className='bordure1' >
                <Grid container spacing={0}>
                   <Grid item xs={12} sm={6} md={4} lg={4}>
                    <SearInputM disabled  notRequired form={props.form} Taille1="100%" Taille2="100%" Titre={informationclient.SearchAgence.Titre} label={informationclient.SearchAgence.label} name={informationclient.SearchAgence.name} Parametre={informationclient.SearchAgence.params} />
                    </Grid>
                      <Grid item xs={12} sm={6} md={8} lg={8}>
                    <SearInputM disabled   notRequired form={props.form} Taille1="100%" Taille2="100%" Titre={informationclient.SearchCompte.Titre} label={informationclient.SearchCompte.label} name={informationclient.SearchCompte.name} Parametre={informationclient.SearchCompte.params} />
                    </Grid>
                  </Grid>
                </Box>

                <Box fontStyle="inherit" className='bordure1' sx={{ display: 'flex', gap: 2 }}>
                  <InputForm icon={<EventIcon color='success' />} label={informationclient.InputDatDeb.label} name={informationclient.InputDatDeb.name} type='date' />
                  <InputForm icon={<EventBusyIcon color='info' />} onChange={handleChangeFin} label={informationclient.InputDatDef.label} name={informationclient.InputDatDef.name} type='date' />
                   <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                      <ButtonI  disabled={props.DataHistor.length>=1?false:true}><PictureAsPdfIcon color='error' /> </ButtonI>
                      <ButtonI disabled={props.DataHistor.length>=1?false:true} onClick={exportExcel}><img style={{ width: 25 }} src={ExcelIcon}></img> </ButtonI>
                    </ButtonGroup>
                </Box>        
                 
                 

                  <Box fontStyle="inherit" className='bordure1'>
                  <Input  addonBefore={<SearchOutlined color='success' />} suffix={sufix} size='large' placeholder="Search Here" onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} />
                  <Table size='small'   sticky={true}   showHeader pagination={false} bordered={true} scroll={{ y: 230, x: 1000 }} columns={columns} dataSource={props.DataHistor} />
                 </Box>

                <Box display={"flex"} width={"98%"} marginTop={"2%"} fontStyle="inherit" className='bordure1'>
                <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
                  <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                  <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                </Space.Compact>
                <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
                  <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
                  <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                </Space.Compact>
              </Box>
           

          </Box>


          <ExcelExport data={DataExcel} fileName="AnyHistoriqueCompte.xlsx" ref={_exporter} onExportComplete={handleExport}>
            <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={200} />
            <ExcelExportColumn field="DEDEVR" title="Date De Valeur" width={350} />
            <ExcelExportColumn field="NUMRAP" title="Reference" />
            <ExcelExportColumn field="LIBELL" title="Libelle" />
            <ExcelExportColumn field="MONTANTDEBIT" title="Debit" />
            <ExcelExportColumn field="MONTANTCREDIT" title="Crédit" />
            <ExcelExportColumn field="SOLDT" title="Total" />
            <ExcelExportColumn field="NBENEF" title="Beneficiare" />
          </ExcelExport>

          <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
            <CircularProgress color="inherit" />
          </Backdrop>
       
      </div>
    </>
  );
}

export default Tab1;